import { useState, useRef, useEffect } from "react";
import '../UtilityComponents/utilityComponent.css';

const CustomDropdown = ({
    label,
    options = [],
    value,
    onChange,
    placeholder = "Select",
    labelKey = "name",
    valueKey = "code",
    isSearchable=true,
    disabled=false,
}) => {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const ref = useRef(null);

    // Close on outside click
    useEffect(() => {
        const handleClick = (e) => {
            if (ref.current && !ref.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClick);
        return () => document.removeEventListener("mousedown", handleClick);
    }, []);

    const selectedOption = options.find(
        (opt) => opt[valueKey] === value
    );

    const filteredOptions = options.filter((opt) =>
        opt[labelKey]?.toLowerCase()?.includes(search?.toLowerCase())
    );

    return (
        <div className="customDropdownParent">
            <div className="custom-select" ref={ref}>
                {label && <label className="select-label">{label}</label>}

                <div
                    className={`select-box ${disabled ? "disabled" : ""}`}
                    onClick={() => {
                        if (!disabled) setOpen(!open);
                    }}
                >
                    {selectedOption ? selectedOption[labelKey] : placeholder}
                    <i class="fa fa-chevron-down"></i>
                </div>

                {open && (
                    <div className="dropdown">
                        {isSearchable &&<input
                            type="text"
                            className="search-input"
                            placeholder="Search..."
                            disabled={disabled}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            autoFocus
                        />}
                        <div className="optionBox">
                        {filteredOptions.length ? (
                            filteredOptions.map((opt) => (
                                <div
                                    key={opt[valueKey]}
                                    className="option"
                                    onClick={() => {
                                        if (disabled) return;
                                        onChange(opt);
                                        setOpen(false);
                                        setSearch("");
                                    }}
                                >
                                    {opt[labelKey]}
                                </div>
                            ))
                        ) : (
                            <div className="no-data">No data found</div>
                        )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomDropdown;
